<template>
    <article class="media">
      <figure class="media-left">
        <router-link :to="routerLink">
          <p class="image is-64x64">
            <img :src="project.image[0].sizes.icon" alt="Project logo">
          </p>
        </router-link>
      </figure>
      <div class="media-content">
        <div class="content">
          <p>
            <router-link :to="routerLink">
              <strong>{{project.name}}</strong>
            </router-link>
            <br>
            {{project.pitch}}
          </p>
        </div>
      </div>
      <div class="media-right">
        <button @click="approve()" class="button is-success is-outlined" :class="{ 'is-loading': isLoading }">Approve</button>
      </div>
    </article>
</template>

<style scoped>
    strong { color: #444; }
</style>

<script>
export default {
  name: 'ApproveProject',
  data () {
    return {
      isLoading: false,
      routerLink: ''
    }
  },
  mounted: function() {
    this.routerLink = '/project/' + this.$props.project.id;
  },
  methods: {
    approve() {
        this.isLoading = true;
        this.$http.post(this.$hostname + '/university/' + this.$props.univId + '/projects/' + this.$props.project.id + '/approve').then(function(response) {
            this.isLoading = false;

            this.$toast.open({
              message: 'Approved the project ' + this.$props.project.name,
              type: 'is-success',
              queue: false
            })

            // Notify parent that this project was approved
            this.$emit('project-approved', this.$props.project);
        });
    }
  },
  props: ['project', 'univId']
}
</script>



// WEBPACK FOOTER //
// src/components/ApproveProject.vue